<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />
    <div>
       <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />

        <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:10px !important;padding-inline-end:33px;`">
            <v-col cols="12" md="10" sm="12" :style="`direction:`+lang.dir+`;text-align:`+lang.algin">
                <form autocomplete="off">
                    <v-row>

                    </v-row>
                </form>
            </v-col>
            <v-col cols="12" md="2" sm="12" class="pt-9" :style="`direction:`+lang.ldir+`;text-align:`+lang.lalgin">
                <button id="multiply-button" :style="`direction:`+lang.dir" :class="`multiply-button-`+lang.lalgin" @click="_AddPurch()" v-b-toggle.add_starter_inventory>
                    <div style="width:150px" :class="`multiply-button-content-`+lang.lalgin">{{lang.add_sinventory}}</div>
                </button>
            </v-col>
            <v-col cols="12" md="12" sm="12" :style="`direction:`+lang.dir+`;margin-top:3px;text-align:`+lang.align">
                <v-data-table
                    :headers="headers"
                    :items="tblrows"
                    :search="search"
                    :items-per-page="15"
                    class="elevation-1"
                    hide-default-footer
                >
                <template v-slot:item="row">
                <tr>
                    <td class="text-center" style="width:70px">{{ row.item.date }}</td>
                    <td class="text-center" nowrap>{{ row.item.add_by }}</td>
                    <td class="text-center" nowrap>{{ row.item.created_date }}</td>
                    <td class="text-center" nowrap>{{ row.item.updated_by }}</td>
                    <td class="text-center" nowrap>{{ row.item.updated_date }}</td>
                    <td class="text-center" nowrap>{{ row.item[`status_${lang.langname}`] }}</td>

                    <td class="text-center" style="width:70px;background:blue;border-bottom:2px solid #FFF !important;">
                    <v-btn style="font-size:0.2em;background:blue;width:70px;color:#FFF;height:25px !important;"  v-b-toggle.add_starter_inventory @click="showStarer(row.item.id)">
                        {{lang.view}}
                    </v-btn>
                    </td>
                </tr>
                </template>

                </v-data-table>

            </v-col>
        </v-row>
    </div>
        <Footer />
        <add_starter_inventory ref="addSInv" />
        <div class="loadingPage" v-if="$store.state.showLoading">
        <v-progress-circular
            :width="3"
            color="green"
            indeterminate
        ></v-progress-circular>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import add_starter_inventory from '@/components/add_starter_inventory.vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import ExportsPrint from '@/components/exports-print.vue';
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default{
    components:{
        breadCrumbs,TabsComp,
        HeaderPortrate,Footer, ExportsPrint,add_starter_inventory
    },
    data() {
        return {
            cpage:0,
            id:0,
            active_tab:2,
            search: '',
            tblrows:[],
            // sdate: '',
            // edate: '',
            vendor_name: '',
            mobile: '',
            invoiceno: '',
            page: 1,
            pageCount:0,
            sd: {
                day: 1,
                month: (new Date()).getMonth(),
                year: (new Date()).getFullYear(),
            },
            ed: {
                day: (new Date()).getDate() + 1,
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            }
        }
    },
    computed: {
       lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        sdate: function() {
            return (new Date(this.sd.year,this.sd.month-1, this.sd.day+1)).toISOString().substring(0,10);
        },
        edate: function() {
            return (new Date(this.ed.year,this.ed.month-1, this.ed.day+1)).toISOString().substring(0,10);
        },
        yearsList: function(){
            const start_year = this.$store.state.licenseType.startYear;
            let t = [{text: this.lang.year, value: -1}];
            for(let i=0;i<100;i++){
            if(parseInt(start_year) + i <= (new Date()).getFullYear()){
                t.push({text: start_year + i, value: start_year+i})
            }

            }
            return t
        },
        daysList: function(){
            return [
            {text: this.lang.day, value: -1},
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
            {text: 8, value: 8},
            {text: 9, value: 9},
            {text: 10, value: 10},
            {text: 11, value: 11},
            {text: 12, value: 12},
            {text: 13, value: 13},
            {text: 14, value: 14},
            {text: 15, value: 15},
            {text: 16, value: 16},
            {text: 17, value: 17},
            {text: 18, value: 18},
            {text: 19, value: 19},
            {text: 20, value: 20},
            {text: 21, value: 21},
            {text: 22, value: 22},
            {text: 23, value: 23},
            {text: 24, value: 24},
            {text: 25, value: 25},
            {text: 26, value: 26},
            {text: 27, value: 27},
            {text: 28, value: 28},
            {text: 29, value: 29},
            {text: 30, value: 30},
            {text: 31, value: 31},
            ]
        },
        monthsList: function(){
            return [
            {text: this.lang.chose_month, value: -1},
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
            {text: 8, value: 8},
            {text: 9, value: 9},
            {text: 10, value: 10},
            {text: 11, value: 11},
            {text: 12, value: 12},
            ]
        },
        headers: function() {
            return [
                {
                    text: this.lang.date,
                    align: 'center',
                    sortable: false,
                    value: 'vendor',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: "اضافة بواسطة",
                    align: 'center',
                    sortable: false,
                    value: 'vendor',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: "تاريخ الاضافة",
                    align: 'center',
                    sortable: false,
                    value: 'bill_date',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: "اخر تعديل",
                    align: 'center',
                    sortable: false,
                    value: 'bill_date',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: "تاريخ اخر تعديل",
                    align: 'center',
                    sortable: false,
                    value: 'bill_date',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: "الحالة",
                    align: 'center',
                    sortable: false,
                    value: 'bill_date',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.action,
                    align: 'center',
                    sortable: false,
                    class:"backBlack",
                    value: 'none',
                    printRemove: 1
                }
            ]
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
        items: function() {
            return {
                    text: this.lang.purchase,
                    disabled: true,
                    to: '/finance/purchase',
                }
        },
        ptotals: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].total) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
        pvat: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].vat) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
        pftotals: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].ftotal) + parseFloat(x);
            }
            return this.$RoundNum(x);
        }
    },
    methods: {
        collectSearch(){
            return {
                module: 'inventoryStart',
                elements: {
                    status: 1
                }
            }
        },
        getStartDate(){
            let d = (new Date()).getDate();
            let m = (new Date()).getMonth() + 1;
            let y = (new Date()).getFullYear();
            if(parseInt(d) < 30){
            d = parseInt(30) - parseInt(d);
            if(parseInt(m) == 1){
                m = 12
                y = parseInt(y) - 1
            }
            else if(parseInt(m) > 1){
                m = parseInt(m) - 1;
            }
            }else if(parseInt(d) == 30){
            d = 1;
            }else{
            d = parseInt(d) - parseInt(30);
            }
            this.sd.day = 1;
            this.sd.month = 1;
            this.sd.year = y;
        },

        preparedata(){
            let exdata = {
                list: "purchaseList",
                title: this.lang.purchase,
                data: [],
            }
            for(let i=0;i<this.purchrows.length;i++){
                exdata.data.push(this.purchrows[i]);
            }
            // // console.log(exdata);
            this.$refs.exportbar.exportdata = exdata;
            this.$refs.exportbar.sdate = this.sdate;
            this.$refs.exportbar.edate = this.sdate;

        },
        _AddPurch(){

            this.$refs.addSInv.newrow = {
                id: 0,
                item_id: '',
                item_code: '',
                item_name: '',
                qty: 0,
            };
            this.$refs.addSInv.item_rows = [];
            this.$refs.addSInv.id = 0;
            this.$refs.addSInv.status = 1;
            this.$refs.addSInv.store_id = 1;

        },
        exportE(type){
            let url = '';
            if(type == 'e'){
                url = this.$store.state.SAMCOTEC.e_path;
            }else{
                url = this.$store.state.SAMCOTEC.pd_path;
            }
            const myhead = this.headers;
            const mydata = this.purchrows;
            const reportname = 'فواتير المشتريات';
            const period = this.sdate + ' - ' + this.edate;
            const head = []
            const keys = []

            if(myhead.length > 0){
                for(let i = 0;i < myhead.length;i++){
                    head.push(myhead[i].text);
                    if(myhead[i].text != 'الاجراء')
                        keys.push(myhead[i].value);
                }
            }

            const post = new FormData();
            post.append("export" , 'inrecepit');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("keys",keys);
            post.append("header",head);
            if(mydata.length > 0){
                for(let i = 0;i< mydata.length;i++){
                    for(const [key, value] of Object.entries(mydata[i])){
                       post.append('data['+i+']['+key+']',value);
                    }
                }
            }
            post.append("reportname",reportname);
            post.append("period",period);
            axios.post( url , post)
            .then((res) => {
                window.open('../api/'+res.data.url,'_blank');
            })
        },
        printMe(item){
            const post = new FormData();
            post.append('export','inrecepit');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type',1);
            post.append('id',item.id);
        },
        ExportIt(type){
            let url = this.$store.state.SAMCOTEC.e_path+'?';
            if(type != 'e'){
                let url = this.$store.state.SAMCOTEC.pd_path+'?inrecepit';
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('export','inrecepit');
            post.append('type',1);
            post.append('sdate','');
            post.append('edate','');
            axios.post(
                url, post
            ).then((res) => {
                var rest = res.data;
                window.open('../api' + rest.url,'_blank')
            })
        },
        ViewItem(item){
            this.$refs.viewMenow.billid = item.id;
            this.$refs.viewMenow.getBill();

            //this.$router.push({path: '/view-purchase/'+item.id})
        },
        getNext(page){
            this.cpage = parseInt(page) - 1;
            this.getInvoice();
        },
        getInvoice(){
            const post = new FormData();
            post.append('type','getPurchase');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',this.id);
            post.append('data[sdate]',this.sdate);
            post.append('data[edate]',this.edate);
            post.append('data[type]',1);
            post.append('data[vendor_name]',this.vendor_name);
            post.append('data[mobile]',this.mobile);
            post.append('data[invoiceno]',this.invoiceno);
            post.append('data[cpage]',this.cpage);
            this.$store.state.showLoading = true
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.$store.state.showLoading = false
                const res = response.data;
                this.pageCount = parseInt(response.data.results.allres)/15
                if((parseFloat(this.pageCount) - parseInt(this.pageCount)) != 0)
                    this.pageCount = parseInt(parseInt(response.data.results.allres)/15) +1;

                this.purchrows = res.results.data;
            });
        },
        showStarer(id){
            this.$refs.addSInv.newrow = {
                id: 0,
                item_id: '',
                item_code: '',
                item_name: '',
                qty: 0,
            };
            this.$refs.addSInv.item_rows = [];
            this.$refs.addSInv.id = id;
            this.$refs.addSInv.getStarterInventory();
        },
        delItem(item)
        {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','delPurchase');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',item.id);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.getInvoice();
            });
        },
        getStarterInv()
        {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getStarterInv');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]','0');
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.tblrows = res.results.data;
            });
        }
    },
    created() {
        // this.getStartDate();
        this.getStarterInv();
    },

}
</script>